import styled from 'styled-components';

export const SelectTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #0c0833;
  margin: 0px;
`;
export const SelectDescription = styled.div`
  color: #0c0833;
  font-size: 16px;
  font-weight: 300;
`;
export { RadioList } from './RadioList';
export { SelectOption } from './SelectOption';
